import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon, MinusIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { useControlledState } from '@prophecy/utils/react/hooks';
import { useId } from 'react';
import { Stack } from '../Layout';
import { renderWithTooltip } from '../Tooltip';
import { LabelWithHint } from '../Typography/LabelWithHint';
import { StyledCheckboxRoot, StyledCheckboxIndicator, CheckboxLabel, StyledHelpText } from './styled';
import { Size } from './types';
export const Checkbox = ({ checked, defaultChecked, indeterminate, disabled, onChange, children, size = Size.s, hint, tooltip, helpText, 'data-test-id': dataTestId, 'aria-label': ariaLabel, id: propId, ...restProps }) => {
    const generatedId = useId();
    const checkboxId = propId ?? generatedId;
    const [checkedState, setCheckedState] = useControlledState({
        value: indeterminate ? 'indeterminate' : checked,
        defaultValue: defaultChecked,
        onChange: (value) => onChange?.(value)
    });
    let checkBoxUI = (_jsx(StyledCheckboxRoot, { id: checkboxId, checked: !!checkedState, size: size, defaultChecked: !!defaultChecked, onCheckedChange: setCheckedState, disabled: Boolean(disabled), "$indeterminate": checkedState === 'indeterminate', "aria-label": ariaLabel, "data-test-id": dataTestId, ...restProps, children: _jsxs(StyledCheckboxIndicator, { children: [checkedState === 'indeterminate' && _jsx(MinusIcon, { type: 'default', size: size }), checkedState === true && _jsx(CheckIcon, { type: 'default', size: size })] }) }));
    if (hint && !children) {
        checkBoxUI = _jsx(LabelWithHint, { hint: hint, children: checkBoxUI });
    }
    const childrenUI = hint && children ? _jsx(LabelWithHint, { hint: hint, children: children }) : children;
    const checkboxContent = (_jsxs(Stack, { gap: theme.spaces.x2, children: [_jsxs(Stack, { direction: 'horizontal', gap: theme.spaces.x8, alignY: 'center', children: [checkBoxUI, childrenUI && (_jsx(CheckboxLabel, { as: 'label', htmlFor: checkboxId, level: 'sm', size: size, disabled: Boolean(disabled), "data-test-id": `${dataTestId}-label`, children: childrenUI }))] }), helpText && _jsx(StyledHelpText, { children: helpText })] }));
    if (tooltip) {
        return renderWithTooltip(checkboxContent, tooltip);
    }
    return checkboxContent;
};
